import { render, staticRenderFns } from "./PrimaryButtonInversed.vue?vue&type=template&id=6b2544cf&scoped=true&"
import script from "./PrimaryButtonInversed.vue?vue&type=script&lang=js&"
export * from "./PrimaryButtonInversed.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryButtonInversed.vue?vue&type=style&index=0&id=6b2544cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2544cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
